var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xiQ-Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card_Account",
    transform: "translate(-59.000000, -242.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(20.000000, 240.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(37.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_sent_2027553",
    transform: "translate(2.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.226652579,4.91944763 L4.68508961,7.31508516 L7.08149951,11.7720852 C7.1574956,11.9113665 7.30188816,12 7.46147994,12 C7.47161275,12 7.48174556,12 7.49187837,12 C7.66160296,11.9873381 7.80599553,11.8784455 7.8667924,11.7189051 L11.9731142,0.578937342 C12.0313779,0.421929386 11.9933798,0.244662338 11.8743193,0.125640177 C11.7552588,0.00661801635 11.5779346,-0.0313677796 11.420876,0.0268771075 L0.282383042,4.13440785 C0.122791262,4.19265273 0.0138635388,4.33953114 0.00119752448,4.50920103 C-0.0114684898,4.67887092 0.0771936102,4.83841126 0.226652579,4.91944763 Z M7.38548385,10.5210863 L5.53371256,7.07450845 L10.4861241,2.12369305 L7.38548385,10.5210863 Z M9.87562226,1.51338792 L4.92574388,6.46420333 L1.47552159,4.61302888 L9.87562226,1.51338792 Z",
    id: "Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend5);
export default __webpack_public_path__ + "static/media/Send (5).a5afa854.svg";
export { ForwardRef as ReactComponent };